import { getStoreState } from 'config/store'
import { getEmbedId } from 'modules/embed/selectors'
import { getEmbedLocale } from 'modules/embed/utils'
import { getPageHref, getSessionGeoInfo, getSessionId, getSiteVisits } from 'modules/session/selectors'
import { path, pathOr } from 'ramda'
import { CampaignDisplayType } from 'types/campaigns'
import { CTAType } from 'types/message'

import { UnreadCampaign } from './types'

type UnreadCampaignsById = Record<string, UnreadCampaign>

export const getUnreadCampaignsById = (): UnreadCampaignsById => {
  const { campaigns } = getStoreState()
  const { unreadCampaigns } = campaigns

  const campaignsById: UnreadCampaignsById = {}

  for(const unreadCampaign of unreadCampaigns) {
    const campaignId = pathOr<number>(null, ['conversation', 'campaignId'], unreadCampaign)

    if (!campaignId) {
      return null
    }

    campaignsById[campaignId] = unreadCampaign
  }

  return campaignsById
}

export const isActiveWelcomeMessageCampaign = (state): boolean => {
  const activeCampaignDisplayType = path(['campaigns', 'activeCampaign', 'attributes', 'campaignDisplayType'], state)
  return activeCampaignDisplayType === CampaignDisplayType.WELCOME_MESSAGE
}

export const getHasChatCtaForActiveCampaign = (state): boolean => {
  const activeCampaignCtaType = path(['campaigns', 'activeCampaign', 'attributes', 'cta', 'CtaType'], state)
  return activeCampaignCtaType === CTAType.CHAT_RESPONSE
}

export const hasActiveCampaign = (state): boolean => !!path(['campaigns', 'activeCampaign', 'id'], state)

export const getActiveCampaignPlaybookId = (state): number | null => pathOr(null, ['campaigns', 'activeCampaign', 'attributes', 'playbookId'], state)

export const getActiveCampaignId = (state): number | null => pathOr(null, ['campaigns', 'activeCampaign', 'id'], state)

export const getEnrolledCampaignIds = (state): number[] => path(['campaigns', 'enrolledCampaignIds'], state)

export const getEnrolledInteractionIds = (state): number[] => path(['campaigns', 'enrolledInteractionIds'], state)

export const getContextForPreRenderedCampaigns = (state) => {
  return {
    embedId: getEmbedId(state),
    geoLocation: getSessionGeoInfo(state),
    locale: getEmbedLocale(),
    pageUrl: getPageHref(state),
    sessionId: getSessionId(state),
    siteVisits: getSiteVisits(state)
  }
}
